import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Typography } from '@mui/material';
import { t } from 'i18next';
import { useSelector } from 'react-redux';
import './RequestEquivalenciesTable.css';
import { RootState, useAppDispatch } from '../../../../shared/redux/store';
import { useEffect } from 'react';
import { fetchCardinality, resetCardinality } from '../../requestSearchSlice';
import Equivalency from '../../../../models/Equivalency';
import { AccessAlarm, CheckCircleOutline, ErrorOutline, BlockRounded } from '@mui/icons-material';
import { Cardinality } from '../../../../models/Cardinality';
import EmptyMessage from '../../../../components/Alerts/EmptyMessage';

const RequestEquivalenciesTable = () => {
  const request = useSelector((state: RootState) => state?.requestSearch?.searchRequest);
  const equivalencies = request?.equivalencies?.equivalencies || [];
  const cardinality = useSelector((state: RootState) => state?.requestSearch.cardinality)
  const dispatch = useAppDispatch()
  useEffect(() => {
    if (equivalencies && equivalencies.length > 0) {
      const rulesIds = equivalencies.map((eq: Equivalency) => eq.rule.id);
      dispatch(fetchCardinality({ ruleIds: Array.from(new Set(rulesIds)) }));
    } else {
      dispatch(resetCardinality());
    }
  }, [request])

  const getStatus = (state: string) => {
    const equivalency = equivalencies.find((equivalency: { state: string; rule: { id: string; }; }) => {
      return equivalency.rule.id === state
    });
    switch (equivalency?.state) {
      case 'APPROVED':
        return <Tooltip placement='top' arrow title={<>{t('grantedActivityMesage')}</>}>
          <div style={{ cursor: 'pointer' }} data-testid={'row-ckeck-icon'}>
            <CheckCircleOutline color='secondary' />
          </div>
        </Tooltip>;
      case 'PENDING':
        return <Tooltip placement='top' arrow title={<>{t('proposalActivityMesage')}</>}>
          <div style={{ cursor: 'pointer' }} data-testid={'row-alarm-icon'}>
            <AccessAlarm color='info' />
          </div>
        </Tooltip>
      case 'REJECTED':
        return <Tooltip placement='top' arrow title={<>{t('errorequivalencyMesage')}</>}>
          <div style={{ cursor: 'pointer' }} data-testid={'row-rounded-icon'}>
            <BlockRounded color='error' />
          </div>
        </Tooltip>
      default:
        return <Tooltip placement='top' arrow title={<>{t('warningActivityMesage')}</>}>
          <div style={{ cursor: 'pointer' }} data-testid={'rowIcon'}>
            <ErrorOutline color='warning' />
          </div>
        </Tooltip>;
    }
  }

  return (<>
    <Typography
      variant="h6"
      color="primary"
      mb={4}
      mt={6}
    >
      {t('manageRequestEquivalencies') as string}
    </Typography>

    <Paper variant="outlined" sx={{ width: '100%' }}>
      <TableContainer >
        <Table className="EQXXI-RequestRequest-ActivitiesTable" size="small">
          <TableHead >
            <TableRow>
              <TableCell align="center" className='EQXXI-RequestRequest-Border'>
                <Typography><>
                  {t('state')}</> </Typography>
              </TableCell>
              <TableCell className="EQXXI-RequestRequest EQXXI-RequestRequest-Border" >
                <Typography>
                  <>
                    {t('sourceTableTitle')}
                  </>
                </Typography>
              </TableCell>
              <TableCell className="EQXXI-RequestRequest" >
                <Typography><>
                  {t('equivalencyGranted')}</> </Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody className="REQXXI-EquivalencyRule-TableBody" data-testid="request-equivalency-table-body" style={{ overflow: 'auto' }}>
            {
              cardinality?.length === 0
                ? <EmptyMessage />
                : cardinality?.map((row: Cardinality, tableRowIndex: number) => {
                  const maxRows = Math.max(row.source_activities.length, row.target_activities.length);
                  const renderActivity = (activity: { id: string; name: string; code: string } | null) => {
                    if (!activity) return null;
                    return (
                      <div>
                        <p>{activity.name}</p>
                      </div>
                    );
                  };
                  return Array.from({ length: maxRows }).map((_, rowIndex) => {
                    return (
                      <TableRow key={rowIndex + row.source_activities[rowIndex]?.id + row.target_activities[rowIndex]?.id} sx={{ position: 'relative' }}>
                        <TableCell className='EQXXI-RequestRequest-Border' align="center" scope="row" sx={{ backgroundColor: tableRowIndex % 2 === 0 ? '#efefef !important' : '#FFF !important' }}>
                          {row.target_activities[rowIndex] || row.target_activities.length === 0 ? (
                            <div>{getStatus(row.id || '')}</div>
                          ) : (
                            <div style={{ height: '40px' }}></div>
                          )}
                        </TableCell>
                        <TableCell className="EQXXI-RequestRequest EQXXI-RequestRequest-Border" sx={{ backgroundColor: tableRowIndex % 2 === 0 ? '#efefef !important' : '#FFF !important' }}>
                          <Typography>{rowIndex < row.source_activities.length ? renderActivity(row.source_activities[rowIndex]) : null}</Typography>
                        </TableCell>
                        <TableCell className="EQXXI-RequestRequest" sx={{ backgroundColor: tableRowIndex % 2 === 0 ? '#efefef !important' : '#FFF !important' }}>
                          {/* Display the target if it exists for this row index */}
                          {row.target_activities[rowIndex] ? (
                            <Typography>{renderActivity(row.target_activities[rowIndex])}</Typography>
                          ) : (
                            <div style={{ height: '40px' }}></div>
                          )}
                        </TableCell>
                      </TableRow>
                    );
                  });
                })
            }
          </TableBody>
        </Table>
      </TableContainer >
    </Paper>
  </>);
};

export default RequestEquivalenciesTable;
